import React, { useState, useRef, useEffect } from 'react';
import { Space, Tooltip, Typography } from 'antd';
import { IconFont } from '../IconFont';
import './style.less';
import { useInViewport } from "ahooks";
import { EllipsisText } from '../EllipsisText';
import classNames from 'classnames';

export type RowAction = {
  key?: string;
  label?: React.ReactNode;
  icon?: string | React.ReactNode;
  onClick: () => void;
};

export interface TableRowGroupProps {
  title: React.ReactNode;
  onTitleClick?: () => void;
  actions?: RowAction[];
  footerActions?: RowAction[];
  className?: string;
  width?: number;
  height?: number;
  editClick?: (() => void | false) | boolean;
  copyClick?: (() => void | false) | boolean;
}

export const TableRowGroup: React.FC<TableRowGroupProps> = ({
  title,
  onTitleClick,
  actions = [],
  footerActions = [],
  className = '',
  width = 200,
  height = 36,
  editClick = false,
  copyClick = false,
}) => {
  const actionsRef = useRef<HTMLDivElement>(null);
  const [showActions, setShowActions] = useState(false);

  const [inViewport] = useInViewport(actionsRef);
  useEffect(() => {
    if (inViewport && !showActions) {
      setShowActions(true);
    }
  }, [inViewport]);

  return (
    <div className={`g-table-row flex-col-center items-start ${className}`} style={{ width, height }}>
      {/* 第一行 */}
      <div className="first-row w-full">
        <div className="flex-1 min-w-0 mr-[16px] cursor-pointer" onClick={onTitleClick}>
          {typeof title === 'string' ? (
            <Typography.Paragraph className='font-14 text-[#0077FD] font-medium !mb-0' ellipsis={{ tooltip: title }}>
              {title}
            </Typography.Paragraph>
          ) : (
            title
          )}
        </div>
        <Space size={8} className="hidden row-actions flex-shrink-0" ref={actionsRef}>
          {showActions && (
            <>
              {typeof editClick === 'function' && (
                <Tooltip title="编辑">
                  <span
                    className="text-[#8c8c8c] cursor-pointer"
                    onClick={(e) => {
                      e.stopPropagation();
                      editClick();
                    }}
                  >
                    <IconFont type="icon-edit-big" />
                  </span>
                </Tooltip>
              )}
              {typeof copyClick === 'function' && (
                <Tooltip title="复制">
                  <span
                    className="text-[#8c8c8c] cursor-pointer"
                    onClick={(e) => {
                      e.stopPropagation();
                      copyClick();
                    }}
                  >
                    <IconFont type="icon-pages" />
                  </span>
                </Tooltip>
              )}
              {actions.map((action) => (
                <Tooltip key={action.key} title={action.label}>
                  <span
                    className="text-[#8c8c8c] cursor-pointer"
                    onClick={(e) => {
                      e.stopPropagation();
                      action.onClick();
                    }}
                  >
                    {typeof action.icon === 'string' ? <IconFont type={action.icon} /> : action.icon}
                  </span>
                </Tooltip>
              ))}
            </>
          )}
        </Space>
      </div>

      {/* 底部操作 */}
      {footerActions.length > 0 && (
        <div className="hidden row-actions row-footer">
          {showActions && footerActions.map((action) => (
            <span
              key={action.key}
              className="mr-[16px] font-12 font-medium cursor-pointer"
              onClick={(e) => {
                e.stopPropagation();
                action.onClick();
              }}
            >
              {action.label}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};
